// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1bAUq","content":"ManualTimeModal_content__3J-3C"};